<template>
  <!-- color="transparent" -->
  <v-footer
    dark
    color="transparent"
    absolute
    height="auto">
    <v-spacer></v-spacer>

    <v-btn
      small
      color="rgba(255,255,255,0.3)"
      @click.stop="impressumDialog = true">
      Impressum
    </v-btn>
    <!-- <v-card
      class="flex"
      color="transparent"
      flat
      tile>
      <v-card-actions
        color="transparent">
        -->
 
    <!-- </v-card-actions> -->
    <!-- </v-card> -->

    <v-dialog 
      v-model="impressumDialog" 
      scrollable
      width="600px">
      <app-impressum @close-dialog="impressumDialog = false"></app-impressum>
    </v-dialog>
  </v-footer>
</template>


<script>
import Impressum from '@/components/global_comps/Impressum.vue'

export default {
  components: {
    // eslint-disable-next-line
    "app-impressum": Impressum
  },
  data () {
    return  {
      impressumDialog: false
    }
  },
   
}
</script>

<style scoped>

#impressumbtn {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
